import { Component, Input} from '@angular/core';
import { DataService} from '../../core/data.service';
import { Pet} from './pet';
import { Observable } from 'rxjs';
import { CustomAuthService} from '../../auth.service';
import { Page} from '../../core/Page';
import { ImageUploadService } from 'src/app/shared/image-upload/image-upload.service';
import { ImageUpload } from 'src/app/core/ImageUpload';
import { HIUser } from 'src/app/core/HIUser';
import {UploadService} from '../../services/upload.service';

@Component({
  selector: 'pets-component',
  styleUrls:  ['pets.component.scss'],
  templateUrl: 'pets.component.html',
  providers:  [ DataService ]
})
export class PetsComponent {
   @Input()
  set user(user: number) {
    this.customerSid = user;
    if (user) {
          this.loadPets();
    }
  }

  petList$: Observable<Page<Pet>>;
  customerSid: number;
    // showModal: false;


    typeOfPets: string[] = ['CAT', 'DOG'];
    opened = false;
    selectedPet: Pet = new Pet('blank');

    petRows: Pet[] = [];
    petFiles = [] as any;
    pagePets: Observable<Page<Pet>>;
    petImage: ImageUpload;

  constructor ( private dataService: DataService,
                public  authService: CustomAuthService,
                private s3Service: UploadService,
                private imageUploadService: ImageUploadService,
                ) { }

  loadPets() {
    this.petList$ = this.dataService.callGetPaged('pet/userId/' + this.customerSid, null);
    this.petList$.subscribe(
        x => {
            if (x.content) {
              this.petRows = [];
              x.content.forEach( pet => {
                  const p = new Pet(pet.name);
                  p.fromImport(pet);
                  if (p.pic && !p.pic.startsWith('asset')) {
                    this.fetchPetPicture(pet);
                  }
                  this.petRows.push(p);
              });
              this.petRows.push(new Pet('Add Pet'));
          }

        },
        error => {
            console.log(error);
        }
    );
  }


  fetchPetPicture(pet: Pet) {
  this.imageUploadService.fetchPetImage(pet.pic)
    .then(
      (img) => {
        this.petRows.find(it => it.sid === pet.sid).displayPic = 'data: image/png;base64,' + img;
      },
      (err) => console.log(err)
    );
  }

  handleSavedPet(savedPet: Pet) {
    if (savedPet.sid == null) {
      console.log('Saving pet');
      if (this.customerSid) {
        const owner  =  new HIUser();
        owner.sid = this.customerSid;
        savedPet.owner = owner;
      }
      this.dataService.callPost('pet', JSON.stringify(savedPet)).subscribe(
        (resp) => {
            console.log('done', resp);
            const newPetId = resp.headers.get('location').substring(resp.headers.get('location').lastIndexOf('/') + 1);
            // this.uploadImage(newPetId);
            this.s3Service.uploadFile(newPetId);
        },
        error => {
            console.log(error);
        }
        );
    } else {
        console.log('Updating Pet');
        this.dataService.callPut('pet', JSON.stringify(savedPet)).subscribe(
          () => {
            // this.uploadImage(savedPet.sid);
              this.s3Service.uploadFile(savedPet.sid);
              console.log('done');
          },
          error => {
              console.log(error);
          }
      );
    }
    this.opened = false;
  }

    uploadImage(petSid: number) {
      this.loadPets();
    }

    newPet(sid) {
      const image_extentions = ['jpg', 'png', 'gif', 'webp', 'tiff', 'psd', 'raw', 'bmp', 'jpeg', 'svg'];
      this.opened = true;
      if (sid != null) {
          this.selectedPet = this.petRows.find(it => it.sid === sid);
          const that = this;
          this.s3Service.getFile(sid, function (err, data) {
              if (err) {
                  console.log('There was an error getting your files: ' + err);
              } else {
                  const files = data.Contents;
                  files.map(file => {
                      const splitKey = file.Key.split('.');
                      const splitForName = splitKey[0].split('/');
                      file.name = splitForName[splitForName.length - 1];
                      file.extention = splitKey[1].toLowerCase();
                      file.type = image_extentions.includes(file.extention) ? 'image' : 'other';
                  });
                  that.selectedPet.files = files;
              }
          });
      } else {
        this.selectedPet = new Pet('blank');
      }
    }
}
